import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";
// import {
//   useAddDietaryRestrictionMutation,
//   useUpdateDietaryRestrictionMutation,
// } from "../../Data/services/dietaryRestrictionApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
// import {
//   useAddMentalHealthMutation,
//   useUpdateMentalHealthMutation,
// } from "../../Data/services/mentalHealthApi";
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../lib/apiClient";
import { mentalHealthService } from "../../Services/mentalHealthService";

const typeOptions = [
  { value: "10", label: "General" },
  { value: "20", label: "Family" },
];

const EditMentalHealthModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [name, setName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  // const [sending, setSending] = useState(false);

  const [selectedType, setSelectedType] = useState("");
  // console.log(selectedType);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      console.log(editData);
      setRowId(editData.id);
      setName(editData.name || "");
      setSelectedType(String(editData.type) || "");
      setImageUrl(editData.image_url);
      setImagePreview(editData.image_url || "");
    }
  }, [editData]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("path", "category");

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      return response.data[0];
    } catch (error) {
      Toast("Failed to upload image", "error");
    }
  };

  // const { mutate: saveMentalHealth, isPending: sending } = useMutation({
  //   mutationFn: (data) => {
  //     if (editData) {
  //       return apiClient.patch(`mental-healths/${rowId}`, data);
  //     } else {
  //       return apiClient.post('mental-healths', data);
  //     }
  //   },
  //   onSuccess: (response) => {
  //     if (response.code === 200) {
  //       refetch();
  //       SuccessToast(response?.message);
  //       handleEditModalClose();
  //     } else {
  //       Toast(response.message, "error");
  //     }
  //   },
  //   onError: (error) => {
  //     if (error?.data && error?.data?.message) {
  //       Toast(error?.data?.message, "error");
  //     } else {
  //       Toast("An error occurred", "error");
  //     }
  //     handleEditModalClose();
  //   }
  // });

  const { mutate: createCategory, isPending: creating } =
    mentalHealthService.useCreate();
  const { mutate: updateCategory, isPending: updating } =
    mentalHealthService.useUpdatePatch();

  const handleSubmit = async () => {
    if (!name) {
      Toast("Please fill all the fields", "error");
      return;
    }

    const data = {
      name: name,
    };

    // saveMentalHealth(data);

    const mutation = editData ? updateCategory : createCategory;
    const mutationBody = editData ? { id: rowId, body: data } : data;

    mutation(mutationBody, {
      onSuccess: (response) => {
        if (response.code === 200) {
          refetch();
          SuccessToast(response?.message);
          handleEditModalClose();
        } else {
          Toast(response.message, "error");
        }
      },
      onError: (error) => {
        if (error?.data && error?.data?.message) {
          Toast(error?.data?.message, "error");
        } else {
          Toast("An error occurred", "error");
        }
        handleEditModalClose();
      },
    });
  };

  if (!mounted) {
    return null;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              {editData ? "Edit Mental Health" : "Add Mental Health"}
            </p>
            <span
              className=""
              onClick={handleEditModalClose}
              style={{ cursor: "pointer" }}
            >
              <FaCircleXmark color="gray" size="35px" />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Mental Health Name"
                  value={name}
                  onChange={handleNameChange}
                />
              </Col>
            </Row>
            {/* <Row className="mb-3">
              <Col md={12}>
                <SelectFieldComponent
                  optionsList={typeOptions}
                  onSelectChange={(value) => setSelectedType(value)}
                  firstOption={
                    selectedType
                      ? typeOptions.find((o) => o.value === selectedType)?.label
                      : "Select Type"
                  }
                  value={selectedType}
                />
              </Col>
            </Row>
            <Row>
              <Col md={9}>
                <Input
                  classes="mt-2 mb-3"
                  type="file"
                  placeholder="Image"
                  onChange={handleImagePreview}
                />
              </Col>
              <Col md={3}>
                {isUploading ? (
                  <Spinner />
                ) : (
                  <img
                    src={
                      imagePreview || imageUrl || "https://placehold.co/100x100"
                    }
                    alt="category_image"
                    width={100}
                    height={100}
                    className="rounded"
                  />
                )}
              </Col>
            </Row> */}
            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${creating || updating || !name ? "bg-dark-subtle" : "shadow"
                    } `}
                  text={
                    creating || updating ? (
                      <ClipLoader color="#fff" size="22" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={creating || updating || !name}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditMentalHealthModal;
